module.exports = __webpack_public_path__ + "img/loader_small_animation.7557613c.gif";